import styled from 'styled-components';

import { PaginationButtons } from '../../../display/tables/components/PaginationButtons';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const Container = styled.div``;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spaces.m}rem;
    justify-content: center;
  }
`;

export const MainButtonStyled = styled(MainButton)`
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    order: 2;
  }
`;

export const CloseButton = styled(MainButton)`
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    order: 2;
  }
`;

export const PaginationButtonsStyled = styled(PaginationButtons)`
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    order: 1;
    justify-content: center;
    align-items: center;
  }
`;

// Modo RV (2026-07-21) — estado vacío explícito bajo la tabla de RVs destino,
// calcado del EmptyMessage de RelateSegmentModal (misma decisión de UX: decir
// por qué no hay filas en vez de una tabla muda).
export const EmptyMessage = styled.p`
  margin: ${({ theme }) => theme.spaces.m}rem 0 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.S};
  color: ${({ theme }) => theme.colors.greyDark};
`;

// «Convertir actuación» (W4): debajo de la tabla, las dos opciones del doble
// registro, la tabla de Tramos del recorrido elegido y la frase de lo que va a
// pasar. Mismo hueco que el «BelowTable» de «Transferir tramo».
export { BelowTable } from '../TransferSegmentModal/styles';
